import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";

const AddMoreScreen = ({
  isAddMoreOpen,
  closeAddMoreModal,
  uploadAndSaveImg,
}) => {
  const [text, setText] = useState("");
  const [img, setImg] = useState("");
  const [errors, setErrors] = useState({
    img: "",
    text: "",
  });

  useEffect(() => {
    setText("");
    setImg("");
    setErrors({
      img: "",
      text: "",
    });
  }, [isAddMoreOpen]);

  const validateFields = () => {
    let newErrors = { img: "", text: "" };
    if (!img) newErrors.img = "Image is required.";
    if (!text) {
      newErrors.text = "Text is required.";
    } else if (text.trim().split(" ").length > 15) {
      newErrors.text = "Text must be 15 words or fewer.";
    }
    setErrors(newErrors);
    return !newErrors.img && !newErrors.text;
  };

  const handleSave = () => {
    if (validateFields() == false) return;
    uploadAndSaveImg(img, text, "add");
    closeAddMoreModal();
  };

  return (
    <Modal show={isAddMoreOpen} onHide={closeAddMoreModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Onboarding Screen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <Input
            label="Image"
            type="file"
            accept="image/png, image/jpeg"
            value={img}
            onChange={(e) => setImg(e.target.files[0])}
          />
          {errors?.img && <div className="text-danger">{errors?.img}</div>}
        </div>
        <div className="mb-3">
          <Input
            label="Text"
            type="textarea"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          {errors?.text && <div className="text-danger">{errors?.text}</div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Save Changes" callBack={handleSave} />
      </Modal.Footer>
    </Modal>
  );
};

export default AddMoreScreen;
